import React from "react";
import "./Tile.css";
import styles from "./Tile.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsWaiting } from "../../../redux/actions/appActions";

interface ITile {
    tileWidth: string;
    image: string;
    id: number;
    name: string;
    isPublic?: boolean;
    isFromExplore?: boolean;
    itemType?: string;
}

const Tile: React.FC<ITile> = (props) => {
    const { isPublic = true, isFromExplore = false, itemType = "recipe" } = props;
    const urlId = itemType === "recipe" ? props.id : props.name;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (event.button === 0) {
            event.preventDefault();
            dispatch(setIsWaiting(true));
            navigate(`/${itemType}/${urlId}`);
        }
    };

    return (
        <div style={{ width: props.tileWidth }} className={styles.container}>
            <a href={`/${itemType}/${urlId}`} onClick={handleLinkClick}>
                <img className={styles.image} src={props.image} alt={props.name}></img>
                {(!isPublic || isFromExplore) && (
                    <div className={styles.circle}>
                        <div className={styles.icon}>
                            {!isPublic && <i className="bi bi-lock-fill"></i>}
                            {isFromExplore && <i className="bi bi-globe-americas"></i>}
                        </div>
                    </div>
                )}
                <h1 className={styles.title}>{props.name}</h1>
            </a>
        </div>
    );
};

export default Tile;
